import React from 'react'
import { GuestListTableContainer } from './dues.style'
import {
TableHead,
TableBodyRow
} from './../../../../widget/styledComponents/table.style'
import { Checkbox,
  // IconButton,MoreIcon,
  Pagination, Spinner} from 'evergreen-ui';
import { PageTitleText } from '../../../../widget/styledComponents/headings.style';
import DuesAnalyticsWidget from './widgets/analytics';
import {useHistory } from 'react-router-dom';
import { gql, useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import DueDetailInfoWidget from './widgets/due_detail';




export const FETCH_DUES_WITH_ID = gql`
query Due_getByIdAdvanced($dueId: ID!, $pagination: PaginationInput, $minDate: Date, $maxDate: Date) {
  due_getByIdAdvanced(dueId: $dueId, pagination: $pagination, minDate: $minDate, maxDate: $maxDate) {
    due {
      _id
      facility
      properties
      title
      description
      bankAccountId
      defaultAmount
      paymentConfiguration {
        type
        numberOfRooms
        amount
      }
      payerType
      appliesToAllProperties
      startDate
      endDate
      paymentFrequency
      isStarted
      isStopped
      createdAt
      id
    }
    bills {
      _id
      due
      property
      payerType
      amount
      title
      description
      isRecurring
      nextPaymentDate
      status
      resident {
        _id
        name
        email
        address
      }
      owner {
        _id
        name
        email
        address
      }
      paidOn
      paidBy
      paidByType
      transaction {
        _id
        amount
        paymentReference
        narration
        cardDetails {
          expMonth
          maskedPan
          expYear
        }
        bankDetails {
          accountName
          accountNumber
          bankCode
        }
        transactionTime
        id
      }
      receivable {
        _id
        property
        amount
        description
        appliesToBills
        bills
        receivedFrom
        receivedFromType
        receivedOn
        reference
        createdAt
        id
      }
      createdAt
      id
    }
    pendingBillsAmount
    paidBillsAmount
    totalBillsAmount
  }
}
`;



function DuesOnePageWidget(props) {
const { id } = useParams();

console.log("due id",id)
const { loading,error,data }  = useQuery(FETCH_DUES_WITH_ID,{
variables: {
    dueId: id,
    pagination: {
      "cursor": null,
      "limit": 100
    },
    minDate: "2023-02-11",
    maxDate: "2023-02-11",
  }
});

const [checked, setChecked] = React.useState(false)
const history = useHistory()

if (loading) return <Spinner/>;
if (error) return <p>Error: {error.message}</p>;
console.log("=dscsd=")
console.log(data);
const dets = data.due_getByIdAdvanced
  return (
  <div>
    <br/>
    <PageTitleText  onClick={()=>history.push("/dues")}>
        <button className='btn btn-flat transparent'>
            <i className='material-icons'>arrow_back</i>
        </button>
        {dets.title}
    </PageTitleText>
    <br/>
    <DuesAnalyticsWidget style={{
      padding:"0px 16px"
    }} analyticsTabs={dets}/>
    <DueDetailInfoWidget details={dets.due}/>
    
    <GuestListTableContainer>
      <PageTitleText>
          Transaction
      </PageTitleText>
            <table className='responsive-table'>
                <thead>
                <tr>
                    <TableHead>
                        <td>
                            <Checkbox
                            label="#"
                            checked={checked}
                            onChange={e => setChecked(e.target.checked)}
                            />
                        </td>
                    </TableHead>
                    <TableHead>Name</TableHead>
                    <TableHead>Address</TableHead>
                    <TableHead>Amount</TableHead>
                    <TableHead>Payment status</TableHead>
                    <TableHead></TableHead>
                </tr>
                </thead>
                {/* {id} */}
                <tbody>
                   
                {dets &&
                    
                     dets.bills.map((data) => <TableBodyRow
                    >
                            <td 
                                className='pl-2'
                            >
                                <Checkbox
                                    label=""
                                    checked={checked}
                                />
                            </td>
                            <td>Elizabeth Ojo</td>
                            <td>Samuel Street, Block 24a</td>
                            <td>#30,000</td>
                            <td><i className='material-icons'>more_horiz</i></td>
                        </TableBodyRow> 
                    )
                }
                    
                </tbody>
            </table>
            <Pagination className='transparent z-depth-0' page={1} totalPages={5}></Pagination>

        </GuestListTableContainer>
        {/* <DueTransactions id={id} /> */}
    </div>
  )
}

export default DuesOnePageWidget





export const FETCH_PROPERTY_TRANSACTIONS = gql`
query Transactions_getByProperty($propertyId: ID!) {
  transactions_getByProperty(propertyId: $propertyId) {
    _id
    amount
    paymentReference
    narration
    cardDetails {
      expMonth
      maskedPan
      expYear
    }
    bankDetails {
      accountName
      accountNumber
      bankCode
    }
    transactionTime
    id
  }
}
`;

